/**
 * Phase F (freemium): the forced artist-onboarding redirect is retired.
 *
 * This file used to fetch `/api/user/status` on every SSR navigation and trap a
 * freshly self-registered creator on the `/onboarding` wizard until they had
 * created their first artist. Creating an artist is now an invitation, not a
 * gate: the signup lands in the dashboard, which shows a "create your first
 * artist" prompt linking to the same (now skippable) wizard. The matching
 * backend gate is `server/middleware/09.artist-onboarding.ts`, also a no-op now.
 *
 * The file is kept as a no-op rather than deleted because removing a `.global`
 * middleware in Nuxt invalidates the SSR build cache; keeping the empty handler
 * is the safer one-line "off" switch (same call as
 * the subscription gate).
 */
export default defineNuxtRouteMiddleware(() => {
    return
})
